import { ComponentChildren, h } from "preact";

import classname from "../../../foundation/utils/classname";
import IconCloseSmall from "../Icons/IconCloseSmall";

import styles from "./NotificationBanner.module.css";

enum Type {
    Info = "info",
    Warning = "warning"
}

interface Props {
    class?: string;
    type?: Type;
    emoji: string;
    title: ComponentChildren;
    description?: ComponentChildren;
    onClose?: () => void;
}

function NotificationBanner({
    class: cssClass,
    type = Type.Warning,
    emoji,
    title,
    description,
    onClose
}: Props) {
    return (
        <div class={classname(styles.notificationBanner, cssClass, styles[type])}>
            <div class={styles.emojiContainer}>
                <span class="heading-3 medium">{emoji}</span>
            </div>
            <div class={styles.body}>
                <span class="body-1 medium">{title}</span>
                {description && <span class="body-1">{description}</span>}
            </div>
            {onClose && (
                <div
                    class={styles.iconContainer}
                    onClick={onClose}>
                    <IconCloseSmall/>
                </div>
            )}
        </div>

    );
}

export default NotificationBanner;
export {
    Props as NotificationBannerProps,
    Type as NotificationBannerType
};
